module.exports = __webpack_public_path__ + "static/img/wall_right.c48688d8.png";